import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { SnackbarService } from '@shared/services/snackbar.service';
import { valueStartsBy } from '@shared/utils/utils';

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {
  constructor(private snackbar: SnackbarService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          this.snackbar.open({
            text: 'defaults.internet_access_error'
          });
        } else if (valueStartsBy(error.status, 5)) {
          this.snackbar.open({
            text: error.error?.detail || 'defaults.server_error'
          });
        }

        return throwError(() => error);
      })
    );
  }
}
